import {
  Navigate as NavigateFromReactRouter,
  NavigateProps as NativeNavigateProps,
} from 'react-router-dom';

import { useLocationWithOrgId } from 'hooks/useLocationWithOrgId';
import { GetLocationDescriptorSettings } from '@cast/utils';

export type NavigateProps = NativeNavigateProps & GetLocationDescriptorSettings;

export const Navigate = ({ to, ...props }: NavigateProps) => {
  const location = useLocationWithOrgId(to, props);

  return <NavigateFromReactRouter replace {...props} to={location!} />;
};
